<template>
  <div>
    <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="productionManage"
      @reset="resetHandle"
      :selReset="true"
      @select="selectHandle"
      @addOrEdit="addEditHandle"
    >
      <template slot="otherBtn">
        <el-button v-if="limits.startAuth" type="primary" :disabled="!selection.length" @click="startHandle">开工</el-button>
        <el-button v-if="limits.pauseAuth" type="primary" :disabled="!selection.length" @click="pauseHandle">暂停</el-button>
        <el-button v-if="limits.printTagAuth" type="primary" :disabled="!selection.length" @click="printTag">标签打印</el-button>
        <el-button v-if="limits.printOrderAuth" type="primary" :disabled="!selection.length" @click="printOrder">工单打印</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="生产中心">
            <el-select v-model="filter.workCenterName" @change="selectChange">
              <el-option v-for="item in workCenterList" :key="item.pkId" :label="item.workCenterName" :value="item.workCenterName" />
            </el-select>
          </el-form-item>
          <el-form-item label="工单状态">
            <el-select v-model="filter.status" placeholder="请选择工单状态" clearable>
              <el-option label="已排产" :value="20" />
              <el-option label="已开工" :value="30" />
              <el-option label="已暂停" :value="40" />
              <el-option label="已完工" :value="80" />
            </el-select>
          </el-form-item>
          <el-form-item label="派工单号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入派工单号" clearable />
          </el-form-item>
          <el-form-item label="工单编号">
            <el-input v-model.trim="filter.productionOrderNo" placeholder="请输入工单编号" clearable />
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable />
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable />
          </el-form-item>
          <el-form-item label="入库状态">
            <el-select v-model="filter.warehousingStatus" placeholder="请选择入库状态" clearable>
              <el-option label="未入库" :value="0" />
              <el-option label="入库中" :value="2" />
              <el-option label="已入库" :value="1" />
            </el-select>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable />
          </el-form-item>
          <el-form-item label="销售单号">
            <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入销售单号" clearable />
          </el-form-item>
          <el-form-item label="合同号" label-width="64px">
            <el-input v-model.trim="filter.customerContractNo" placeholder="请输入合同号" clearable />
          </el-form-item>
          <el-form-item label="开工日期">
            <el-date-picker
              v-model="startDate"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="startDateChange"
            />
          </el-form-item>
          <el-form-item label="完工日期">
            <el-date-picker
              v-model="finishDate"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="finishDateChange"
            />
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <DispatchDetail ref="dispatchDetail"></DispatchDetail>
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import DispatchDetail from "@/views/ProductionManagement/ProductionOrder/DispatchDetail.vue";
export default {
  components: { viewTable, DispatchDetail },
  data() {
    return {
      limits: {
        printTagAuth: this.$auth(191),
        printOrderAuth: this.$auth(192),
        startAuth: this.$auth(193),
        pauseAuth: this.$auth(194),
      },
      workCenterList: [],
      selection: [],
      ids: [],
      filter: {
        workCenterName: "",
        status: "",
        billNo: "",
        productionOrderNo: "",
        materialNo: "",
        materialName: "",
        warehousingStatus: "",
        customerName: "",
        salesOrderNo: "",
        customerContractNo: "",
        planStartFrom: "",
        planStartTo: "",
        planFinishFrom: "",
        planFinishTo: "",
      },
      startDate: "",
      finishDate: "",
      columnsProperty: [
        {
          tooltip: true,
          key: "statusName",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "feedingStatusName",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "verificationStatusName",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "warehousingQuantity",
          width: 90,
          align: "center",
        },
        {
          key: "routingName",
          width: 150,
          tooltip: true,
        },
        {
          tooltip: true,
          key: "billNo",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  color: "#2d8cf0",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    this.$refs.dispatchDetail.open(params.row.pkid, true);
                  },
                },
              },
              params.row.billNo
            );
          },
        },
        {
          tooltip: true,
          key: "productionOrderNo",
          width: 150,
          align: "center",
        },
        {
          tooltip: true,
          key: "prodOrderTypeName",
          width: 100,
          align: "center",
        },
        {
          key: "materialName",
          minWidth: 360,
          tooltip: true,
        },
        {
          tooltip: true,
          key: "materialNo",
          width: 160,
          align: "center",
        },
        {
          tooltip: true,
          key: "planStartTime",
          width: 160,
          align: "center",
        },
        {
          tooltip: true,
          key: "planFinishTime",
          width: 160,
          align: "center",
        },
        {
          key: "specification",
          width: 220,
          tooltip: true,
        },
        {
          tooltip: true,
          key: "materialHeight",
          width: 100,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialWidth",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialLength",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialWeight",
          width: 90,
          align: "center",
        },
        {
          key: "workCenterName",
          width: 150,
          tooltip: true,
        },
        {
          tooltip: true,
          key: "quantity",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "outputQuantity",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "unitName",
          width: 80,
          align: "center",
        },
        {
          tooltip: true,
          key: "salesOrderNo",
          width: 150,
          align: "center",
        },
        {
          tooltip: true,
          key: "customerContractNo",
          width: 150,
          align: "center",
        },
        {
          key: "customerName",
          width: 220,
          tooltip: true,
        },
        {
          key: "projectName",
          width: 220,
          tooltip: true,
        },
        {
          tooltip: true,
          key: "deliveryDate",
          width: 120,
          align: "center",
        },
        {
          key: "salesOrderMaterialNote",
          width: 220,
          tooltip: true,
        },
      ],
    };
  },

  mounted() {
    this.getWorkCenters();
  },

  methods: {
    getWorkCenters() {
      this.$http.get("basic", "workCenters/employee/list").then((res) => {
        if (res.success) {
          this.workCenterList = res.data;
          this.filter.workCenterName = res.data[0].workCenterName;
        }
      });
    },

    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },

    addEditHandle(row) {
      this.$refs.dispatchDetail.open(row.pkid);
    },

    startDateChange(date) {
      if (date) {
        this.filter.planStartFrom = date[0];
        this.filter.planStartTo = date[1];
      } else {
        this.filter.planStartFrom = "";
        this.filter.planStartTo = "";
      }
    },

    finishDateChange(date) {
      if (date) {
        this.filter.planFinishFrom = date[0];
        this.filter.planFinishTo = date[1];
      } else {
        this.filter.planFinishFrom = "";
        this.filter.planFinishTo = "";
      }
    },

    // 标签打印
    printTag() {
      if (this.selection.length > 1) {
        this.$confirm("请选择一条数据打印", "错误", {
          type: "error",
          showCancelButton: false,
        });
        return;
      }
      this.$http.get("basic", `productionManage/printsn?id=${this.selection[0].pkid}`).then((res) => {
        if (res.success) {
          if (res.data.length) {
            if (!res.data[0].prodType) {
              const params = {
                unitName: this.selection[0].unitName,
                materialName: this.selection[0].materialName,
                spec: this.selection[0].specification,
                billNo: this.selection[0].billNo,
                salesOrderNo: this.selection[0].salesOrderNo,
                data: res.data,
              };
              this.goTo("/materialsTagsPrint", JSON.stringify(params));
            } else {
              const params = {
                orderInfo: this.selection[0],
                data: res.data,
              };
              this.goTo("/productCardPrint", JSON.stringify(params));
            }
          }
        }
      });
    },

    // 工单打印
    printOrder() {
      if (this.selection.length > 1) {
        this.$confirm("请选择一条数据打印", "错误", {
          type: "error",
          showCancelButton: false,
        });
        return;
      }
      this.goTo("/productOrderPrint", JSON.stringify(this.selection[0]));
    },

    // 跳转打印页面
    goTo(path, params) {
      const routeUrl = this.$router.resolve({
        path: path,
        query: {
          params: params,
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    // checkBox
    selectHandle(selection) {
      this.selection = selection;
      this.ids = [];
      this.selection.forEach((item) => {
        this.ids.push(item.pkid);
      });
    },

    resetHandle(filter) {
      this.startDate = "";
      this.finishDate = "";
      this.filter = filter;
      this.filter.workCenterName = this.workCenterList[0].workCenterName;
      this.loadData(1);
    },

    selectChange() {
      this.loadData(1);
    },

    startHandle() {
      const arr = this.selection.filter((item) => item.status !== 40);
      if (arr.length) {
        this.$confirm("请选择已暂停的生产任务", "错误", {
          type: "error",
          showCancelButton: false,
        });
      } else {
        this.$http.post("basic", "productionManage/start", this.ids).then(() => {
          this.loadData();
          this.$message.success("操作成功");
          this.selection = [];
        });
      }
    },

    pauseHandle() {
      const arr = this.selection.filter((item) => item.status !== 30);
      if (arr.length) {
        this.$confirm("请选择已开工的生产任务", "错误", {
          type: "error",
          showCancelButton: false,
        });
      } else {
        this.$http.post("basic", "productionManage/pause", this.ids).then(() => {
          this.loadData();
          this.$message.success("操作成功");
          this.selection = [];
        });
      }
    },
  },
};
</script>
